import { render, staticRenderFns } from "./createUserForm.vue?vue&type=template&id=2088dd73"
import script from "./createUserForm.vue?vue&type=script&lang=js"
export * from "./createUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2088dd73')) {
      api.createRecord('2088dd73', component.options)
    } else {
      api.reload('2088dd73', component.options)
    }
    module.hot.accept("./createUserForm.vue?vue&type=template&id=2088dd73", function () {
      api.rerender('2088dd73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/components/createUserForm.vue"
export default component.exports